// extracted by mini-css-extract-plugin
export default {"ShowcaseTeam":"ShowcaseTeam_ShowcaseTeam__xk+2d","container":"ShowcaseTeam_container__mkmk0","teamHeader":"ShowcaseTeam_teamHeader__ZtS9G","teamInfo":"ShowcaseTeam_teamInfo__te26X"};